import { ChargeNoun } from "../types";
import { ChargeFieldName, InterestDirection } from "./types";

// Shared by ChargeField and its compact twin so the two surfaces can't name a field differently — lives here, not in the component, like CHARGE_VALIDATORS.
export const CHARGE_LABELS: Record<ChargeNoun, string> = {
  fee: "Fee",
  withholdingTax: "Tax",
};

// Each charge binds the key its payload sends, so a tax can't be submitted as a fee.
export const CHARGE_FIELD_NAMES: Record<ChargeNoun, ChargeFieldName> = {
  fee: "feeEur",
  withholdingTax: "taxWithheld",
};

/** Shared by interest recording and correction forms. */
export const INTEREST_DIRECTION_SEGMENTS: Array<{
  value: InterestDirection;
  label: string;
}> = [
  { value: "EARNED", label: "Earned" },
  { value: "CHARGED", label: "Charged" },
];

/** What the direction control means, on both surfaces that render it. */
export const INTEREST_DIRECTION_HELPER =
  "Earned credits the account's cash; charged debits it.";

export const INTEREST_DIRECTION_LABEL = "Direction *";
export const INTEREST_DIRECTION_GROUP_LABEL = "Interest direction";
export const ADJUSTMENT_DIRECTION_GROUP_LABEL = "Adjustment direction";

// Cap must match the server's @MaxLength(255) on TradeDTO.note exactly.
export const NOTE_LABEL = "Note";
export const NOTE_MAX_LENGTH = 255;
export const NOTE_HELPER =
  "Optional — what this charge was for, e.g. exchange connectivity.";
export const NOTE_PLACEHOLDER = "Optional";

// Reported rather than truncated: a DOM maxLength would silently drop the tail of a pasted note, and the server answers 400 for the same length.
export const noteRule = {
  maxLength: {
    value: NOTE_MAX_LENGTH,
    message: `Note cannot exceed ${NOTE_MAX_LENGTH} characters`,
  },
};

export const CASHBACK_AMOUNT_LABEL = "Paid by cashback";
export const CASHBACK_BUY_AMOUNT_HELPER =
  "Optional — the part of this buy paid by cashback. Leave blank to pay it all in cash.";
export const CASHBACK_CORRECTION_AMOUNT_HELPER =
  "Optional — the part of this buy paid by cashback. Clear it to remove it.";
export const CASHBACK_SOURCE_LABEL = "Cashback from";
export const CASHBACK_SOURCE_HELPER =
  "The account that earned the cashback, ignored while the amount is blank. Accounts with cashback on are listed first.";
